export default __webpack_public_path__ + "static/media/misc-drawerA-768w.eb567e08.png";